@let a = act();
<div class="item" [class.item--faded]="faded()">
  <span
    class="item__dot"
    [class.item__dot--current]="isCurrent()"
    [class.item__dot--base]="a.role === 'base' && !isCurrent()"
    [class.item__dot--applied]="a.role === 'applied' && !isCurrent()"
    aria-hidden="true"></span>
  <div class="item__body">
    <div class="item__line">
      <strong class="item__label">{{ a.label }}</strong>
      <span class="item__kind">{{ kind() }}</span>
      @if (a.registeredAt) {
        <span class="item__date">· registrada {{ a.registeredAt | vaultDate }}</span>
      } @else if (a.signedAt) {
        <span class="item__date">· assinada {{ a.signedAt | vaultDate }}</span>
      } @else if (actDate()) {
        <span class="item__date">· {{ actDate() | vaultDate }}</span>
      }
      @if (isCurrent()) {
        <span class="tag tag--current">vigente</span>
      }
      <span class="tag">{{ roleLabel[a.role] }}</span>
      @if (showStatus()) {
        <span class="tag" [class]="'tag tag--' + statusTone[a.status]">
          @if (a.status === 'processing') {
            <i class="pi pi-spin pi-spinner-dotted" aria-hidden="true"></i>
          }
          {{ statusLabel[a.status] }}
        </span>
      }
    </div>

    @if (changeRows().length > 0) {
      <ul class="changes">
        @for (row of changeRows(); track $index) {
          <li class="changes__row">
            <i class="pi" [class]="'pi ' + row.icon" aria-hidden="true"></i>
            <span class="changes__text">{{ row.change.summary }}</span>
            <app-charter-provenance [from]="row.source" />
          </li>
        }
      </ul>
    } @else if (changesSummary().length > 0) {
      <p class="item__changes">{{ changesSummary().join(' · ') }}</p>
    }

    @if (summary()?.validationIssues?.length) {
      <ul class="item__issues">
        @for (issue of summary()!.validationIssues; track $index) {
          <li>{{ issue }}</li>
        }
      </ul>
    }

    <div class="item__links">
      <button
        type="button"
        class="item__doc"
        [title]="'Abrir ' + a.documentName"
        (click)="openDocument()">
        <i class="pi pi-file-pdf" aria-hidden="true"></i>
        {{ a.documentName }}
      </button>
      <button
        type="button"
        class="item__link"
        [disabled]="openingDocumentId() === a.documentId"
        title="Abrir a pasta do documento no Data Room, com o painel de detalhes"
        (click)="openInDataRoom.emit(a.documentId)">
        <i class="pi pi-folder-open" aria-hidden="true"></i>
        {{ openingDocumentId() === a.documentId ? 'Abrindo...' : 'Ver no Data Room' }}
      </button>
    </div>

    @if (agentInfo(); as info) {
      <div class="agent" aria-label="Leitura do agente (visível só para o time interno)">
        <i class="pi pi-sparkles" aria-hidden="true"></i>
        @if (info.text) {
          <span>{{ info.text }}</span>
        }
        @if (info.processedAt) {
          <span class="agent__muted">lido em {{ info.processedAt | vaultDateTime }}</span>
        }
        @if (isAdmin() && info.sessionId) {
          <button
            type="button"
            class="agent__session"
            [title]="info.jobId ? 'Job ' + info.jobId : 'Abrir a sessão no back office'"
            (click)="openSession(info.sessionId)">
            <i class="pi pi-external-link" aria-hidden="true"></i> Sessão do agente
          </button>
        }
      </div>
    }
  </div>
</div>
